import { useAlert } from 'components/alert'
import { confirm } from 'components/modals/confirm'
import { useCallback } from 'react'

const DEFAULT_SUCCESS_MESSAGE = 'Edição de atestado cancelada com sucesso.'

interface UseAtestadoCancelarEdicaoProps {
  handleModalClose(): void
  successMessage?: string
}

export function useAtestadoCancelarEdicao(props: Readonly<UseAtestadoCancelarEdicaoProps>) {
  const { handleModalClose, successMessage = DEFAULT_SUCCESS_MESSAGE } = props

  const alert = useAlert()

  const cancelarEdicao = useCallback(() => {
    alert('success', successMessage)
    handleModalClose()
  }, [alert, handleModalClose, successMessage])

  return useCallback(
    (hasChanges: boolean) => {
      if (hasChanges) {
        confirm({
          title: 'Deseja cancelar a edição?',
          body: 'As alterações realizadas serão perdidas.',
          cancelLabel: 'Não, continuar edição',
          confirmLabel: 'Sim, cancelar edição',
          onConfirm: cancelarEdicao,
        })()

        return
      }

      handleModalClose()
    },
    [cancelarEdicao, handleModalClose]
  )
}
